<template>
  <div class="ins-main payment-main">
    <div class="pc_model">
      <div class="blackHeading">
        <h1>{{$t('lang_groupHeading_quickCashFlow')}}</h1>
        <h3 v-for='(n,index) in 3' :key="index" v-show="currentItem === index">{{$t(`lang_groupHeading_quickCashFlow_narrative${n}`)}}</h3>
      </div>
      <div id="msgbox" @wheel.prevent="scrollPage">
        <ul class="boxCtrl">
          <li v-for="(list,index) in 3" :key="index" :class="{'active':currentItem === index}" @click='toSection(index)'></li>
        </ul>
        <article>
          <section class="step_section_1" :class="{ left: leftActive, right: rightActive }">
            <div class="pay_process" @mouseover="mouseInLeft(true)" @mouseleave="mouseInLeft(false)">
              <div class="pay_step1_inner">
                <span class="pay_step1_img">
                  <img src="@img/payment/pay_step1_left.png" class="m_out">
                  <img src="@img/payment/pay_step1_left_hover.png" class="m_in">
                </span>
                <span class="pay_step1_title">
                  {{$t('lang_quickPayment_title')}}
                </span>
                <span class="pay_step1_narr" v-html="$t('lang_quickPayment_msg')"></span>
                <router-link to='/experience' class="pay_step1_btn">
                  <i>{{$t('lang_experience')}}</i>
                </router-link>
              </div>
            </div>
            <div class="pay_manage" @mouseover="mouseInRight(true)" @mouseleave="mouseInRight(false)">
              <div class="pay_step1_inner">
                <span class="pay_step1_img">
                  <img src="@img/payment/pay_step1_right.png" class="m_out">
                  <img src="@img/payment/pay_step1_right_hover.png" class="m_in">
                </span>
                <span class="pay_step1_title">
                  {{$t('lang_cashFlow_title')}}
                </span>
                <span class="pay_step1_narr" v-html="$t('lang_cashFlow_msg')"></span>
                <span class="pay_step1_btn" @click='toSection(1)'>
                  <i>{{$t('lang_men_more')}}</i>
                </span>
              </div>
            </div>
          </section>
          <section class="step_section_2">
            <div class="pay_circles">
              <span class="circles_body">
                <img src="@img/payment/circle.png">
                <span class="pay_bracket" v-for='(item,index) in brackets' :class="`pay_bracket_${item}`" :key="index"></span>
              </span>
              <span class="circles_border">
                <img src="@img/payment/circle_border.png">
              </span>
              <div class="pay_info" v-for='(item, i) in brackets' :class="`pay_info_${item}`" :key="i">
                <template v-if="i <3">
                  <span>
                    <img :src="require(`@img/payment/circle_${i+1}.png`)">
                  </span>
                  <span>
                    <h1 v-html="$t(`lang_cashFlow_theme${i+1}_title`)"></h1>
                    <h4 v-html="$t(`lang_cashFlow_theme${i+1}_msg`)"></h4>
                  </span>
                </template>
                <template v-if="i > 2">
                  <span>
                    <h1 v-html="$t(`lang_cashFlow_theme${i+1}_title`)"></h1>
                    <h4 v-html="$t(`lang_cashFlow_theme${i+1}_msg`)"></h4>
                  </span>
                  <span>
                    <img :src="require(`@img/payment/circle_${i+1}.png`)">
                  </span>
                </template>
              </div>
            </div>
          </section>
          <section class="step_section_3">
            <ul class="pay_banklist">
              <li v-for="(item, i) in bankLists" :key='item.alt'>
                <img :src="require(`@img/payment/payment_${i+1}.png`)" :alt="`${item.alt}`">
              </li>
            </ul>
            <router-link to="/platform/pay" class="payment_btn">{{$t('lang_checkOut_supplier_payment')}}</router-link>
          </section>
        </article>
      </div>
    </div>
    <div class="mb_model">
      <router-link to="/experience">
          <div class="payment_tag">
            <img :src="require(`@img/${nowLangx}/mobile/payment/pay_tag.png`)">
          </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import {mapGetters} from 'vuex'

export default {
  name:'Payment',
  data() {
    return {
      leftActive: false,
      rightActive: false,
      pageHeight: '',
      brackets: ['a', 'b', 'c', 'd', 'e'],
      currentItem: 0,
      bankLists: [
        {alt: '支付宝'},
        {alt: '微信支付'},
        {alt: 'QQ钱包'},
        {alt: '中国农业银行'},
        {alt: '中国建设银行'},
        {alt: '招商银行'},
        {alt: '交通银行'},
        {alt: '中国工商银行'},
        {alt: '中国银行'},
        {alt: '广发银行'},
      ],
      isMoving: false
    }
  },
  methods: {
    mouseInLeft(boo) {
      this.leftActive = boo
    },
    mouseInRight(boo) {
      this.rightActive = boo
    },
    showpay() {
      let random = [5,9,6,4,1,3,8,2,7,0];
      for(let i = 0; i <= random.length; i++) {
        $('.pay_banklist li').eq(random[i]).delay(50*i).animate({
          'opacity': 1
        },1000)
      }
    },
    getWinSize(){
      this.setPageHeight()
      this.movePage('resize')
    },
    setPageHeight() {
      let h = window.innerHeight;
      let headerH = $('header').height();
      let titleH = $('.blackHeading').height();
      let showH = h - headerH - titleH
      this.pageHeight = showH
      $('#msgbox').css('height', showH);
    },
    movePage(value) {   
      let speed = value === 'resize' ? 0 : 800
      const $this = this
      $('#msgbox article').animate({
        'margin-top': -($this.pageHeight * $this.currentItem)
      }, speed, function() {
        $this.isMoving = false;
      })

      if($this.currentItem == 2 ) {
        $this.showpay()
      }
    },
    scrollPage(event){
      const $this = this
      if($this.isMoving) {return}

      if( event.deltaY >=100 &&  $this.currentItem < 2) {        
        $this.isMoving = true
        $this.currentItem+=1
        $this.movePage()
      } else if(event.deltaY <0 && $this.currentItem > 0){
        $this.isMoving = true
        $this.currentItem-=1
        $this.movePage()
      }
    },
    toSection(value){
      this.isMoving = true
      this.currentItem = value
      this.movePage()
    },
    goToTop(){
      this.toSection(0)
    }
  },
  computed:{
    ...mapGetters(['nowLangx'])
  },
  mounted() {
    this.setPageHeight();
    window.addEventListener('resize',this.getWinSize)
    $('.gotop span').on('click',this.goToTop)
    this.$store.dispatch('setLoadshow',false)
  },
  beforeDestroy(){
    window.removeEventListener('resize',this.getWinSize)
    $('.gotop span').off('click',this.goToTop)
    this.$store.dispatch('setLoadshow',true)
  }
}
</script>

<style lang="sass">
  @import '@css/payment.sass'
</style>

